import { useEffect } from "react";

type Props = Readonly<{
  onKeyPress: (ev: KeyboardEvent) => void;
}>;

export const KeyboardListener = ({ onKeyPress }: Props) => {
  useEffect(() => {
    window.addEventListener("keydown", onKeyPress);
    return () => {
      window.removeEventListener("keydown", onKeyPress);
    };
  }, [onKeyPress]);
  return null;
};
